import React, { useState } from 'react';

const Loader = () => {
    // eslint-disable-next-line
    const [themeMode, setThemeMode] = useState(localStorage.getItem("quotationTheme") ? localStorage.getItem("quotationTheme") : "default");
    
    return (
        <div>
            <div className="cssload-loading">
                <div className="cssload-finger cssload-finger-1">
                    <div className={`cssload-finger-item ${themeMode}`}>
                        <span></span><i></i>
                    </div>
                </div>
                <div className="cssload-finger cssload-finger-2">
                    <div className={`cssload-finger-item ${themeMode}`}>
                        <span></span><i></i>
                    </div>
                </div>
                <div className="cssload-finger cssload-finger-3">
                    <div className={`cssload-finger-item ${themeMode}`}>
                        <span></span><i></i>
                    </div>
                </div>
                <div className="cssload-finger cssload-finger-4">
                    <div className={`cssload-finger-item ${themeMode}`}>
                        <span></span><i></i>
                    </div>
                </div>
                <div className="cssload-last-finger">
                    <div className={`cssload-last-finger-item ${themeMode}`}><i></i></div>
                </div>
            </div>
        </div>
    );
};

export default Loader;